<app-nav></app-nav>
<div class="hospital-cash">
  <div class="container">
    <div class="breadcumb">
      <ul>
        <li class="active">Select Plan</li>
        <li>Proposal Form</li>
        <li>Payment</li>
      </ul>
    </div>
    <div class="radio-btns">
      <div class="text-center">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/insurer/careLogo.png" class="img-responsive subnission_image1">
      </div>
      <h4>Select Plan</h4>
      <label class="custom-radio">Get ₹<b>2000</b>/day for <b class="blue-color">₹799</b>
        <input type="radio" [(ngModel)]="planValue" [value]="2000" name="radio">
        <span class="checkmark"></span>
      </label>
      <label class="custom-radio">Get ₹<b>3000</b>/day for ₹<b class="blue-color">1199</b>
        <input type="radio" [(ngModel)]="planValue" [value]="3000" name="radio">
        <span class="checkmark"></span>
      </label>
      <label class="custom-radio">Get ₹<b>5000</b>/day for ₹<b class="blue-color">1999</b>
        <input type="radio" [(ngModel)]="planValue" [value]="5000" name="radio">
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="radio-btns">
      <div class="text-center" style="padding-top:3%">
        <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/insurers/reliance_logo.png" class="img-responsive subnission_image2">
      </div>
      <h4>Select Plan</h4>
      <label class="custom-radio">Get ₹<b>1000</b>/day for <b class="blue-color">₹450</b>
        <input type="radio" [(ngModel)]="planValue" [value]="450" name="radio">
        <span class="checkmark"></span>
      </label>
    </div>
    <div class="benfits">
      <h4>Benefits</h4>
      <ul>
        <li>Daily cash payouts on hospitalization due to accidental injury or sickness</li>
        <li>Fixed cash amount payable for each day of hospitalization, irrespective of actual medical costs incurred
        </li>
        <li>Total benefit payable is for a maximum of 30 days per year. </li>
        <li>Per hospitalization claim is allowed upto 7 days.</li>
        <li>First 24 hours (1 day) is deductible from the claim
          Initial waiting period of 30 days, waived in case of hospitalisation due to injury or accident</li>
        <li>Multiple hospitalisations are allowed in a year</li>
        <li>The Policy can be bought for family, including spouse and upto 3 kids</li>
        <li>The policy can be taken along with any other health insurance schemes, ESIC, CGHS, GMC etc.</li>
        <li>Premium amount paid by any mode other than cash is eligible for relief under Section 80D of the Income Tax
          Act.</li>
        <li>Pre-existing diseases are covered after 24 months of waiting period</li>
        <li>Specific diseases are covered after 24 months of waiting period</li>
      </ul>
    </div>
    <div class="text-center">
      <button class="btn btn-orange nxt-btn" (click)="redirectToProposalForm()">Next</button>
    </div>
  </div>
</div>
